import styled from "styled-components";
import { ROLES } from "../../utils/consts";

export const StyledServicesWrapper = styled.div``;
export const StyledAddService = styled.div``;

export const StyledServiceGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(238px, 1fr));
  grid-gap: 20px;
`;

export const StyledServiceLinkWrapper = styled.div`
  border-radius: 5px;
  transition: all .3s ease;
  position: relative;
  
  .connection {
    &__label {
      padding: 10px;
      display: inline-flex;
      align-items: center;
      cursor: pointer;
    }
    
    &__action {
      position: absolute;
      top: 11px;
      right: 11px;
      z-index: 1;
    }
  }
  
  &:hover {
    box-shadow: 0 22px 34px #C4C4C4;
  }
`;

export const StyledServiceLink = styled.div`
  border-radius: 5px;
  transition: all .3s ease;
  &:hover {
    transform: translateY(-15px);
    box-shadow: 0 22px 34px #C4C4C4;
  }
`;

